// must support both client and server components because logo grid is client component and logo slider is server component
import React from "react";
import styles from "./LogoCard.module.scss";
import { HeaderLogoType } from "@/types/PageType";
import { passACFLink } from "@/utils/passACFLink";
import { CustomLink } from "../CustomLink";
import { MediaItem } from "../MediaItem/MediaItem";

interface LogoCardProps {
  show_border_radius: boolean;
  show_box_shadow: boolean;
  element: HeaderLogoType;
  grayscale: boolean;
  cardType?: "slider" | "grid";
  media_format?: {
    mobile: "square" | "magazine" | "widescreen" | "portrait" | "landscape";
    tablet: "square" | "magazine" | "widescreen" | "portrait" | "landscape";
    desktop: "square" | "magazine" | "widescreen" | "portrait" | "landscape";
    fullhd: "square" | "magazine" | "widescreen" | "portrait" | "landscape";
  };
  showBox?: boolean;
  boxBackgroundColor: string;
  skeleton?: boolean;
}

export const LogoCard = ({
  show_border_radius,
  show_box_shadow,
  element,
  grayscale,
  media_format,
  boxBackgroundColor,
  cardType = "slider",
  showBox = false,
  skeleton = false,
}: LogoCardProps) => {
  const skeletonElementClass = skeleton ? "skeleton-element" : "";

  return (
    <div
      data-card-type={cardType}
      data-grayscale={grayscale}
      className={`${styles["logo-element"]} ${showBox ? `is-box-padding ` : ""} ${show_border_radius && showBox ? "has-border-radius" : ""} ${show_box_shadow && showBox ? "has-box-shadow" : ""}`}
      style={
        showBox && boxBackgroundColor
          ? { backgroundColor: `var(--${boxBackgroundColor})` }
          : {}
      }
    >
      <div
        className="is-flex"
        style={{
          height: `${element.height}%`,
        }}
      >
        <MediaItem
          image_desktop={element.image}
          sizes="(max-width: 767px) 33.33vw, (max-width: 1023px) 25vw, (max-width: 1215px) 20vw, 16.67vw"
          className={`${styles["logo"]} ${skeletonElementClass}`}
          objectFit="contain"
          mediaFormat={media_format}
        />
      </div>

      {element.link && (
        <CustomLink
          className={`${styles["logo-link"]} ${skeletonElementClass}`}
          {...passACFLink(element, "link")}
        >
          .
        </CustomLink>
      )}
    </div>
  );
};
